import React from 'react';
import clsx from 'clsx';

/**
 * Status badge component.
 * "Company" in backend enums always means OmniDrive — the platform reviewer.
 */
const CONFIG = {
  NEW:                    { label: 'New',                  cls: 'bg-blue-100 text-blue-800' },
  ASSIGNED:               { label: 'Assigned',             cls: 'bg-yellow-100 text-yellow-800' },
  VENDOR_SUBMITTED:       { label: 'Pending Review',       cls: 'bg-purple-100 text-purple-800' },
  COMPANY_APPROVED:       { label: 'OmniDrive Approved',   cls: 'bg-indigo-100 text-indigo-800' },
  COMPANY_REJECTED:       { label: 'OmniDrive Rejected',   cls: 'bg-orange-100 text-orange-800' },
  PENDING_FINAL_APPROVAL: { label: 'Awaiting CVA Approval', cls: 'bg-amber-100 text-amber-800' },
  CLIENT_APPROVED:        { label: 'Fully Approved',       cls: 'bg-green-100 text-green-800' },
  CLIENT_REJECTED:        { label: 'Account Rejected',     cls: 'bg-red-100 text-red-800' },
  CVA_REJECTED:           { label: 'CVA Rejected',         cls: 'bg-red-100 text-red-800' },
  CANCELLED:              { label: 'Cancelled',            cls: 'bg-gray-100 text-gray-600' },
};

export default function StatusBadge({ status }) {
  const c = CONFIG[status] || { label: status?.replace(/_/g, ' ') || '—', cls: 'bg-gray-100 text-gray-700' };
  return (
    <span
      title={c.label}
      className={clsx('inline-flex max-w-full items-center justify-center whitespace-normal break-words rounded-full px-2.5 py-0.5 text-center text-xs font-medium leading-tight', c.cls)}
    >
      {c.label}
    </span>
  );
}
